import { defineComponent as a, inject as o, createElementBlock as r, openBlock as c, unref as e, normalizeClass as p, renderSlot as n } from "vue";
import { D as d } from "./DescriptionList.keys-BHlHYV6b.js";
const m = ["data-variant"], _ = /* @__PURE__ */ a({
  __name: "DescriptionListTerm",
  setup(l) {
    const i = o(d.key);
    if (!i)
      throw new Error("DescriptionListDetail must be used within a DescriptionList component.");
    const { variant: t } = i;
    return (s, w) => (c(), r("dt", {
      class: p(["stash-description-list-term tw-flex tw-items-center tw-gap-x-1 tw-font-bold tw-text-ice-900", {
        "md:tw-max-w-40 md:tw-basis-2/5": e(t) === "columns",
        "tw-mr-1.5": e(t) === "inline",
        "tw-pb-1.5": e(t) === "stacked",
        "tw-pb-1.5 md:tw-pb-0": e(t) !== "stacked"
      }]),
      "data-test": "stash-description-list-term",
      "data-variant": e(t)
    }, [
      n(s.$slots, "prepend"),
      n(s.$slots, "default"),
      n(s.$slots, "append")
    ], 10, m));
  }
});
export {
  _ as default
};
//# sourceMappingURL=DescriptionListTerm.js.map
